// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"b65f08fd","78":"9837dc44","261":"9a81b64e","338":"e5e1980d","456":"62d071eb","541":"2c582cf1","544":"2d047b9d","576":"e38eaa8c","753":"c6671079","775":"79dd1aaf","980":"bad761e7"}[chunkId] + ".js";
};